import { config } from '../config.js';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export interface ApiAuth {
  idToken?: string;
  devActor?: string;
  impersonationToken?: string;
}

/** One fetch wrapper. Adds the sign-in token and, when active, the impersonation token. */
export async function apiFetch<T>(path: string, auth: ApiAuth, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  if (auth.idToken) headers.set('authorization', `Bearer ${auth.idToken}`);
  if (auth.devActor) headers.set('x-dev-actor', auth.devActor);
  if (auth.impersonationToken) headers.set('x-impersonation', auth.impersonationToken);

  const res = await fetch(`${config.apiUrl}${path}`, { ...init, headers, credentials: 'include' });
  const text = await res.text();
  const body = text ? (JSON.parse(text) as unknown) : null;
  if (!res.ok) {
    const b = (body ?? {}) as { error?: string; message?: string; details?: unknown };
    throw new ApiError(res.status, b.error ?? 'error', b.message ?? res.statusText, b.details);
  }
  return body as T;
}
